import {
  CHECKOUT,
  GUEST_CART_UPDATE,
  GUEST_SIGNUP,
  GUEST_UPDATE,
  USER,
} from "./constants";
import { http } from "./httpServices";

export function signUpGuest(guestId) {
  return http.get(`${USER}${GUEST_SIGNUP}`, { params: { guestId } });
}

export function updateGuest(data) {
  return http.post(`${USER}${GUEST_UPDATE}`, data);
}

export function updateGuestCart(cartId) {
  return http.get(`${CHECKOUT}${GUEST_CART_UPDATE}`, { params: { cartId } });
}
